import { Component, OnInit,ViewChild } from '@angular/core';
import { SidebarComponent } from '@syncfusion/ej2-angular-navigations';
@Component({
  selector: 'app-community-product-upload',
  templateUrl: './community-product-upload.component.html',
  styleUrls: ['./community-product-upload.component.scss']
})
export class CommunityProductUploadComponent implements OnInit {
  
  constructor() { }

  ngOnInit(): void {
  }
 
}
